import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { Component, createContext } from 'react';
import { getClosestFocusableElement } from '../utils';
var SetRefContext = /*#__PURE__*/createContext();

var FocusGroup = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FocusGroup, _Component);

  function FocusGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "nodes", {});

    _defineProperty(_assertThisInitialized(_this), "setRef", function (id) {
      return function (node) {
        if (_this.context) {
          _this.context(id)(node);
        }

        if (node) {
          _this.nodes[id] = node;
        } else {
          delete _this.nodes[id];
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "isElementOutside", function (target) {
      return Object.values(_this.nodes).every(function (node) {
        return node !== target && !node.contains(target);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "maybeRestoreFocus", function (nextFocusedElement, event) {
      var focusableElement = nextFocusedElement ? getClosestFocusableElement(nextFocusedElement.parentNode) : null;

      if (focusableElement) {
        var observer = new MutationObserver(function (mutationsList) {
          for (var _iterator = _createForOfIteratorHelperLoose(mutationsList), _step; !(_step = _iterator()).done;) {
            var mutation = _step.value;

            if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
              var removedElement = mutation.removedNodes[0];

              if (removedElement === nextFocusedElement && focusableElement.focus) {
                (function () {
                  var previousScrollY = window.pageYOffset;
                  focusableElement.focus();

                  if (_this.isElementOutside(focusableElement)) {
                    _this.props.onBlur(event);
                  }

                  setTimeout(function () {
                    window.scroll(0, previousScrollY);
                  });
                })();
              }
            }
          }
        });
        observer.observe(nextFocusedElement.parentNode, {
          childList: true
        });
        setTimeout(function () {
          observer.disconnect();
        }, 800);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "requestBlur", function (event) {
      var nextFocusedElement = event.relatedTarget || document.activeElement;

      _this.maybeRestoreFocus(nextFocusedElement, event);

      if (_this.isElementOutside(nextFocusedElement)) {
        _this.props.onBlur(event);
      }
    });

    return _this;
  }

  var _proto = FocusGroup.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(SetRefContext.Provider, {
      value: this.setRef
    }, this.props.children({
      setRef: this.setRef,
      requestBlur: this.requestBlur
    }));
  };

  return FocusGroup;
}(Component);

_defineProperty(FocusGroup, "defaultProps", {
  onBlur: function onBlur() {
    return null;
  }
});

_defineProperty(FocusGroup, "contextType", SetRefContext);

export default FocusGroup;